import React, {useState} from 'react';
import {Link} from 'react-router-dom';
import {AurSwitch} from '../../../common/aur-switch/AurSwitch';

const Switch: React.FC = () => {
  const [isActive, setIsActive] = useState<boolean>(true);

  const toggleSwitch = () => {
    if (isActive) setIsActive(false);
    else setIsActive(true);
  };

  return (
    <>
      <div style={{marginBottom: '64px'}}>
        <h1>Switch</h1>
        <div>Switches toggle the state of a single setting on or off.</div>

        <Link to="/demo">Return</Link>
        <hr />
        <div style={{marginBottom: '32px'}}>
          <AurSwitch checked={isActive} onChange={toggleSwitch} />
        </div>
      </div>
    </>
  );
};

export default Switch;
